import dayjs from 'dayjs'

export default function getMaxReturnDate(startDate) {
  return dayjs(startDate, 'DD-MM-YYYY')
    .add(60, 'days')
    .format('DD/MM/YYYY')
}
